export enum PrimeTrialPromoContextualId {
  QUESTION_QUOTA = 1,
  DOUBTS_QUOTA = 2,
  DOUBTS = 3,
  VIDEO = 4,
  TEST = 5,
  QUESTION_BANK = 6,
  PYQ = 7,
  MAIN_SCREEN = 8,
  PYQ_QUOTA = 9,
  COMPETE = 10,
  COMPETE_EXHAUSTED = 11
}

export interface PrimeTrialPromoModalProps {
  open: boolean;
  onClose: () => void;
  onJoinPrime: () => void;
  heroVideoUrl: string;
  brandLogoSrc: string;
  primeLogoSrc: string;
  priceImageSrc: string | null;
  headline: string;
  thenLine: string;
  primaryCtaLabel: string;
  benefits: {
    logoSrc: string;
    title: string;
    subtitle: string;
  }[];
}

export interface PrimePitchAnalyticsContext {
  lessonUid?: string;
  contentVideoUid?: string;
  testUid?: string;
  practiceUid?: string;
  analyticsPitchSource?: string;
}

/** `null` = stay on page, `'back'` = history.back(), path string = custom route, omitted = Prime tab */
export type PrimePitchDismissNavigation = string | 'back' | null;

export interface PrimePitchOpenOptions {
  dismissNavigateTo?: PrimePitchDismissNavigation;
  analyticsContext?: PrimePitchAnalyticsContext;
  onDismiss?: () => void;
  onJoinPrime?: () => void;
}

export interface PrimeTrialPromoApiResponse {
  isRenew: boolean;
  benefits: {
    logoUrl: string;
    subTitle: string;
    title: string;
  }[];
  videoUrl: string;
  contextualText: {
    primaryText: string;
    secondaryText: string;
    tertiaryText: string | null;
  };
  ctaDetails: {
    price: string;
    ctaPriceText: string;
    skuUid: string;
  };
  primeLogoUrl: string;
  priceImageUrl: string | null;
  faqs: {
    question: string;
    answer: string;
  }[];
}
